import LeaEditTableInput from "../edit-table/LeaEditTableInput.js";

export default LeaEditTableInput;
